import React, { useState, useEffect } from "react";

//import components
import DropdownSelect from "../../../assets/reusableComponents/dropDownSelect";
import { ToastContainer, toast, Zoom } from "react-toastify";

//functions for data fetching
import { useSelector } from "react-redux";

//import resize function
import { vw, vh } from "../../../assets/reusableComponents/resizeFunction";


const HouseMoadal = ({
  setShowModal,
  passedHouseInformation,
  setHouseInformation,
  handleConfirmEdit,
}) => {
  //redux methods

  // data fetched from the store
  const { houses } = useSelector((state) => state.landlordslice);

  //navigation variables
  const [isCancelButtonHovered, setIsCancelButtonHovered] = useState(false);
  const [isNextButtonHovered, setIsNextButtonHovered] = useState(false);

  //role variables
  const houseChoices = [
    "Bed Sitter",
    "One Bedroom",
    "Two Bedroom",
    "Three Bedroom",
    "Office",
    "Shop",
  ];
  const [selectedHouseType, setSelectedHouseType] = useState(
    passedHouseInformation?.houseType === 'bed-sitter'
      ? "Bed Sitter"
      : passedHouseInformation?.houseType === "one-bedroom"
      ? "One Bedroom"
      : passedHouseInformation?.houseType === "two-bedroom"
      ? "Two Bedroom"
      : passedHouseInformation?.houseType === "three-bedroom"
      ? "Three Bedroom"
      : passedHouseInformation?.houseType === "office"
      ? "Office"
      : "Shop"
  );
  const [houseNumber, setHouseNumber] = useState(
    passedHouseInformation?.houseNumber
  );
  const [meterNumber, setMeterNumber] = useState(
    passedHouseInformation?.meterNumber
  );
  const [rent, setRent] = useState(passedHouseInformation?.rent);
  const [initialWaterReading, setInitialWaterReading] = useState(
    passedHouseInformation?.initialWaterMeterReading
  );

  useEffect(() => {
    setSelectedHouseType(passedHouseInformation?.houseType === 'bed-sitter' ? "Bed Sitter" : passedHouseInformation?.houseType === "one-bedroom" ? "One Bedroom" : passedHouseInformation?.houseType === "two-bedroom" ? "Two Bedroom" : passedHouseInformation?.houseType === "three-bedroom" ? "Three Bedroom" : passedHouseInformation?.houseType === "office" ? "Office" : "Shop");

    setHouseNumber(passedHouseInformation?.houseNumber);
    setMeterNumber(passedHouseInformation?.meterNumber);
    setRent(passedHouseInformation?.rent);
    setInitialWaterReading(passedHouseInformation?.initialWaterMeterReading);
  }, [passedHouseInformation]);

  useEffect(() => {
    console.log("selected house type updated:", selectedHouseType);
}, [selectedHouseType]);

  //methods
  const closeModal = () => {
    setShowModal(false);
  };

  const confirmEdit = () => {
    const houseTypeMap = {
      "Bed Sitter": 'bed-sitter',
      "One Bedroom": "one-bedroom",
      "Two Bedroom": "two-bedroom",
      "Three Bedroom": "three-bedroom",
      "Office": "office",
      "Shop": "shop"
    };
    const newInformation = {
      house_id: passedHouseInformation.house_id,
      type: houseTypeMap[selectedHouseType] || 'bed-sitter',
      house_no: houseNumber,
      rent,
      meter_no: meterNumber,
      occupation_status: passedHouseInformation.occupation_status,
      initial_meter_reading: initialWaterReading,
      isNewRow: passedHouseInformation.isNewRow,
    };
    handleConfirmEdit(newInformation);
    closeModal();
  };

  const handleCancelEdit = () => {
    closeModal();
    setHouseInformation({});
  };

  //information not passed
  const [selectedHouseToEdit, setSelectedHouseToEdit] = useState(
    houses[0]?.house_no
  );
  const confirmHouseNumberSelect = () => {
    const selectedHouse = houses.find(
      (house) => house.house_no === selectedHouseToEdit
    );
    if (selectedHouse) {
      setHouseInformation({
        house_id: selectedHouse._id,
        houseNumber: selectedHouse.house_no,
        houseType: selectedHouse.type,
        meterNumber: selectedHouse.meter_no,
        rent: selectedHouse.rent,
        initialWaterMeterReading: selectedHouse.initial_meter_reading,
        occupationStatus: selectedHouse.status === " vacant" ? 0 : 1,
        isNewRow: false,
      });
    } else {
      toast.error("House not found");
    }
  };

  //styles
  const styles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0, 0, 0, 0.7)", // Dark translucent overlay
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 9999,
    },
    modalContent: {
      backgroundColor: "white",
      padding: vh(20),
      borderRadius: vw(8),
      width: "90%", // Adapt to smaller screens
      maxWidth: vw(500),
      boxShadow: "0 5px 15px rgba(0, 0, 0, 0.3)",
      position: "relative",
      zIndex: 10000, // Ensure it's above the overlay
      animation: "fadeIn 0.3s ease",
      fontFamily: "Karla, sans-serif",
      overflowX: "hidden",
    },

    titles: {
      display: "flex",
      flexDirection: "column",
      alignItems: "start",
      justifyContent: "center",
      marginBottom: vh(20),
    },
    mainTitle: {
      fontSize: vh(24),
      fontWeight: "700",
      marginBottom: vh(5),
    },
    subTitle: {
      fontSize: vh(16),
      fontWeight: "300",
      color: "#666",
    },

    propertyDescriptionDetails: {},
    propertyName: {
      position: "relative",
    },
    inputContainer: {
      display: "flex",
      justifyContent: "space-between",
      gap: vh(10),
    },
    input: {
      width: "100%",
      padding: vh(10),
      marginBottom: vh(10),
      borderRadius: vw(5),
      border: "1px solid #ccc",
      fontSize: vh(16),
    },
    select: {
      width: "100%",
      padding:vh(10),
      marginBottom: vh(10),
      borderRadius: vw(5),
      border: "1px solid #ccc",
      fontSize: vh(16),
    },

    buttonsContainer: {
      marginTop: vh(20),
      width: "100%",
      display: "flex",
      justifyContent: "space-between",
    },
    cancelButton: {
      width: "50%",
      padding: vh(10),
      color: "white",
      borderRadius: vw(5),
      backgroundColor: "#B39359",
      border: "none",
      cursor: "pointer",
      marginRight: vw(10),
      transition: "background-color 0.3s ease",
    },
    cancelButtonHover: {
      backgroundColor: "#192A3A",
    },
    nextButton: {
      width: "50%",
      padding: vh(10),
      backgroundColor: "#192A3A",
      color: "white",
      borderRadius: vw(5),
      border: "none",
      cursor: "pointer",
      transition: "background-color 0.3s ease",
    },
    nextButtonHover: {
      backgroundColor: "#B39359",
    },
  };

  return (
    <div style={styles.overlay} onClick={closeModal}>
      <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        {Object.keys(passedHouseInformation).length === 0 ? (
          <>
            <div style={styles.titles}>
              <div style={styles.mainTitle}>Edit House</div>
              <div style={styles.subTitle}>
                Modify Details of a specific house
              </div>
            </div>
            <div style={styles.roleTakersDescriptionDetails}>
              <div>
                <label>House Number</label>
                <DropdownSelect
                  choices={houses.map((house) => house.house_no)}
                  defaultChoice={selectedHouseToEdit}
                  onSelect={(choice) => setSelectedHouseToEdit(choice)}
                />
              </div>
            </div>

            <div style={styles.buttonsContainer}>
              <button
                style={{
                  ...styles.cancelButton,
                  ...(isCancelButtonHovered ? styles.cancelButtonHover : {}),
                }}
                onClick={handleCancelEdit}
                onMouseEnter={() => setIsCancelButtonHovered(true)}
                onMouseLeave={() => setIsCancelButtonHovered(false)}
              >
                Cancel
              </button>

              <button
                style={{
                  ...styles.nextButton,
                  ...(isNextButtonHovered ? styles.nextButtonHover : {}),
                }}
                onMouseEnter={() => setIsNextButtonHovered(true)}
                onMouseLeave={() => setIsNextButtonHovered(false)}
                onClick={() => {
                  confirmHouseNumberSelect();
                }}
              >
                Confirm
              </button>
            </div>
          </>
        ) : (
          <>
            <div style={styles.stepsSlider}>
              <div style={styles.individualStepContainer}>
                <div style={styles.titles}>
                  <div style={styles.mainTitle}>Edit House</div>
                  <div style={styles.subTitle}>
                    Modify Details of a specific house
                  </div>
                </div>
                <div style={styles.roleTakersDescriptionDetails}>
                  <div>
                    <label>House Type</label>
                    <DropdownSelect
                      choices={houseChoices}
                      defaultChoice={selectedHouseType}
                      onSelect={(choice) => setSelectedHouseType(choice)}
                    />
                  </div>
                  <div>
                    <label>House Number</label>
                    <input
                      style={styles.input}
                      type="text"
                      placeholder="e.g. A01"
                      value={houseNumber}
                      onChange={(e) => setHouseNumber(e.target.value)}
                    />
                  </div>
                  <div>
                    <label>Electricity Meter Number</label>
                    <input
                      style={styles.input}
                      type="text"
                      placeholder="e.g. 1234567"
                      value={meterNumber}
                      onChange={(e) => setMeterNumber(e.target.value)}
                    />
                  </div>
                  <div>
                    <label>Rent</label>
                    <input
                      style={styles.input}
                      type="number"
                      placeholder="e.g. 10,000"
                      value={rent}
                      onChange={(e) => setRent(e.target.value)}
                    />
                  </div>
                  <div>
                    <label>Initial water reading</label>
                    <input
                      style={styles.input}
                      type="number"
                      placeholder="e.g. 201"
                      value={initialWaterReading}
                      onChange={(e) => setInitialWaterReading(e.target.value)}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div style={styles.buttonsContainer}>
              <button
                style={{
                  ...styles.cancelButton,
                  ...(isCancelButtonHovered ? styles.cancelButtonHover : {}),
                }}
                onClick={handleCancelEdit}
                onMouseEnter={() => setIsCancelButtonHovered(true)}
                onMouseLeave={() => setIsCancelButtonHovered(false)}
              >
                Cancel
              </button>

              <button
                style={{
                  ...styles.nextButton,
                  ...(isNextButtonHovered ? styles.nextButtonHover : {}),
                }}
                onMouseEnter={() => setIsNextButtonHovered(true)}
                onMouseLeave={() => setIsNextButtonHovered(false)}
                onClick={() => {
                  confirmEdit();
                }}
              >
                Confirm
              </button>
            </div>
          </>
        )}
      </div>
      <ToastContainer
        position="bottom-left"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        transition={Zoom}
      />
    </div>
  );
};

export default HouseMoadal;
